export default {
  ALL: 'all',
  TOP_SELLERS: 'top_sellers',
  NEAR_ME: 'near_me',
  MOST_FOLLOWED: 'most_followed',
  PURCHASED_FROM: 'purchased_from',
}
